import React from 'react';

const Footer = () => {
  return (
    <footer className='w-full py-8 px-6 text-gray-400 text-center border-t border-gray-800 bg-black/50 backdrop-blur-sm'>
        <div className='max-w-6xl mx-auto space-y-3'>
            <h1 className='text-2xl font-bold tracking-wider'>
                <span className='text-[#00d59a]'>S</span>
                <span className='text-white mx-1'>·</span>
                <span className='text-[#00d59a]'>K</span>
                <span className='text-white mx-1'>·</span>
                <span className='text-[#00d59a]'>S</span>
            </h1>
            <p className='text-sm'>© {new Date().getFullYear()} Syed Ka Ab Surkhi. All Rights Reserved.</p>
        </div>
    </footer>
  )
};

export default Footer